// @flow

import type { Action } from './store.type';

export const GET_LOCALES_REQUEST = 'GET_LOCALES_REQUEST';
type GET_LOCALES_REQUEST_TYPE = 'GET_LOCALES_REQUEST';

export const GET_LOCALES_SUCCESS = 'GET_LOCALES_SUCCESS';
type GET_LOCALES_SUCCESS_TYPE = 'GET_LOCALES_SUCCESS';

export const GET_LOCALES_FAILURE = 'GET_LOCALES_FAILURE';
type GET_LOCALES_FAILURE_TYPE = 'GET_LOCALES_FAILURE';

type GetLocalesSuccess = {
  data: Object
};

type GetLocalesFailure = {
  error: any
};

// Subscribe plan
type GetLocalesRequestAction = Action<GET_LOCALES_REQUEST_TYPE, null>;

type GetLocalesSuccessAction = Action<GET_LOCALES_SUCCESS_TYPE, GetLocalesSuccess>;

type GetLocalesFailureAction = Action<GET_LOCALES_FAILURE_TYPE, GetLocalesFailure>;

// Default label translations by locale
export const GET_DEFAULT_TRANSLATIONS_BY_LOCALE_REQUEST =
  'GET_DEFAULT_TRANSLATIONS_BY_LOCALE_REQUEST';
type GET_DEFAULT_TRANSLATIONS_BY_LOCALE_REQUEST_TYPE = 'GET_DEFAULT_TRANSLATIONS_BY_LOCALE_REQUEST';

export const GET_DEFAULT_TRANSLATIONS_BY_LOCALE_SUCCESS =
  'GET_DEFAULT_TRANSLATIONS_BY_LOCALE_SUCCESS';
type GET_DEFAULT_TRANSLATIONS_BY_LOCALE_SUCCESS_TYPE = 'GET_DEFAULT_TRANSLATIONS_BY_LOCALE_SUCCESS';

export const GET_DEFAULT_TRANSLATIONS_BY_LOCALE_FAILURE =
  'GET_DEFAULT_TRANSLATIONS_BY_LOCALE_FAILURE';
type GET_DEFAULT_TRANSLATIONS_BY_LOCALE_FAILURE_TYPE = 'GET_DEFAULT_TRANSLATIONS_BY_LOCALE_FAILURE';

type GetDefaultTranslationByLocaleRequestAction = Action<
  GET_DEFAULT_TRANSLATIONS_BY_LOCALE_REQUEST_TYPE,
  null
>;

type DefaultTranslationType = {
  key: string,
  value: string
};

type GetDefaultTranslationByLocaleSuccess = {
  data: { data: Array<DefaultTranslationType>, total: number },
  locale: string
};

type GetDefaultTranslationByLocaleFailure = {
  error: any
};

type GetDefaultTranslationByLocaleSuccessAction = Action<
  GET_DEFAULT_TRANSLATIONS_BY_LOCALE_SUCCESS_TYPE,
  GetDefaultTranslationByLocaleSuccess
>;

type GetDefaultTranslationByLocaleFailureAction = Action<
  GET_DEFAULT_TRANSLATIONS_BY_LOCALE_FAILURE_TYPE,
  GetDefaultTranslationByLocaleFailure
>;

export type TranslationAction =
  | GetLocalesRequestAction
  | GetLocalesSuccessAction
  | GetLocalesFailureAction
  | GetDefaultTranslationByLocaleRequestAction
  | GetDefaultTranslationByLocaleSuccessAction
  | GetDefaultTranslationByLocaleFailureAction;

export type TranslationState = {
  loading: boolean,
  success: boolean,
  error: any,
  locales: Array<string>,
  requestPermissionLocales: boolean,
  primaryLocale: string,
  total: number,
  defaultTranslationsByLocale: Array<Object>
};
